import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, Star, Quote, BadgeCheck } from "lucide-react";
import LandingShell from "../components/LandingShell";
import Btn from "../components/Btn";
import api, { API } from "../lib/api";

export default function TestimoniPage() {
  const [stories, setStories] = useState([]);
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    api.get("/public/success-stories").then(({ data }) => setStories(data.stories)).catch(() => {});
    api.get("/testimonials").then(({ data }) => setReviews(data.testimonials)).catch(() => {});
  }, []);

  return (
    <LandingShell wide title="Testimoni" icon={Award}
      subtitle="Kisah nyata para pejuang yang berhasil lolos bersama SkorUp.io.">
      <div className="space-y-14" data-testid="testimoni-page">
        {/* success stories */}
        <section>
          <div className="flex items-center gap-2 mb-6">
            <BadgeCheck className="w-6 h-6 text-su-success" />
            <h2 className="font-heading font-black text-2xl">Mereka Berhasil Lolos 🎉</h2>
          </div>
          {stories.length === 0 ? (
            <div className="card-chunky p-8 text-center text-su-muted font-medium">
              Belum ada testimoni keberhasilan. Sudah lolos lewat SkorUp? <Link to="/auth" className="text-su-primary font-heading font-bold">Masuk & bagikan kisahmu!</Link>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {stories.map((s) => (
                <div key={s.id} className="card-chunky p-6 flex flex-col" data-testid={`success-story-${s.id}`}>
                  <div className="flex items-center gap-3 mb-3">
                    <img src={`${API}/success-stories/${s.id}/photo`} alt={s.name}
                      className="w-14 h-14 rounded-2xl object-cover border-2 border-su-border"
                      onError={(e) => { e.currentTarget.src = "/brand/skorup_icon.png"; }} />
                    <div className="min-w-0">
                      <p className="font-heading font-black truncate">{s.name}</p>
                      {s.position && <p className="text-xs font-heading font-bold text-su-success truncate">{s.position}</p>}
                    </div>
                  </div>
                  <Quote className="w-5 h-5 text-su-primary/40 mb-1" />
                  <p className="text-su-text font-medium text-sm leading-relaxed">{s.comment}</p>
                </div>
              ))}
            </div>
          )}
        </section>

        {/* platform reviews (Kata Mereka) */}
        {reviews.length > 0 && (
          <section>
            <div className="flex items-center gap-2 mb-6">
              <Star className="w-6 h-6 text-su-energy fill-su-energy" />
              <h2 className="font-heading font-black text-2xl">Kata Mereka ⭐</h2>
            </div>
            <p className="text-su-muted font-medium -mt-4 mb-6">Ulasan bintang 5 seputar pengalaman memakai platform.</p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {reviews.map((t, i) => (
                <div key={i} className="card-chunky p-6" data-testid={`review-${i}`}>
                  <div className="flex gap-0.5 mb-3">{[...Array(5)].map((_, s) => <Star key={s} className="w-4 h-4 text-su-energy fill-su-energy" />)}</div>
                  <p className="text-su-text font-medium mb-4">"{t.comment}"</p>
                  <div className="flex items-center gap-2">
                    <div className="w-9 h-9 rounded-full bg-su-primary/20 grid place-items-center font-heading font-bold text-su-primary">{t.user_name?.[0] || "U"}</div>
                    <span className="font-heading font-bold text-sm">{t.user_name}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        <div className="text-center">
          <Link to="/auth"><Btn size="lg" data-testid="testimoni-cta">Jadi Kisah Sukses Berikutnya</Btn></Link>
        </div>
      </div>
    </LandingShell>
  );
}
